/* ============================================================
   MIRELA — skrypty szablonu produktu
   Bez zależności. Działa z sekcjami mirela-*.
   ============================================================ */
(() => {
  'use strict';

  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Karuzela (galeria, wideo, przed/po) ---------- */
  function initCarousel(root) {
    const track = root.querySelector('[data-track]');
    if (!track) return null;
    const slides = Array.from(track.children);
    const dotsWrap = root.querySelector('[data-dots]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));
    const dots = [];

    if (dotsWrap && slides.length > 1) {
      slides.forEach((_, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'mirela-dot' + (i === 0 ? ' is-active' : '');
        b.setAttribute('aria-label', 'Slajd ' + (i + 1));
        b.addEventListener('click', () => goTo(i));
        dotsWrap.appendChild(b);
        dots.push(b);
      });
    }

    function current() {
      const left = track.scrollLeft;
      let best = 0, dist = Infinity;
      slides.forEach((s, i) => {
        const d = Math.abs(s.offsetLeft - track.offsetLeft - left);
        if (d < dist) { dist = d; best = i; }
      });
      return best;
    }
    function mark(i) {
      dots.forEach((d, di) => d.classList.toggle('is-active', di === i));
      thumbs.forEach((t, ti) => t.classList.toggle('is-active', ti === i));
    }
    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      mark(i);
    }

    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => mark(current()));
    }, { passive: true });

    root.querySelector('[data-prev]')?.addEventListener('click', () => goTo(current() - 1));
    root.querySelector('[data-next]')?.addEventListener('click', () => goTo(current() + 1));
    thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.thumb))));
    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current() + 1); }
    });

    return { goTo, slides };
  }

  /* ---------- Szuflada koszyka ---------- */
  class Drawer {
    constructor(el, currency) {
      this.el = el;
      this.items = el.querySelector('[data-drawer-items]');
      this.foot = el.querySelector('[data-drawer-foot]');
      this.total = el.querySelector('[data-drawer-total]');
      this.emptyHTML = this.items.innerHTML;
      this.fmt = new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency || 'PLN' });
      this.lastFocus = null;

      el.querySelectorAll('[data-drawer-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.isOpen()) this.close(); });

      this.items.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        const line = btn.closest('[data-key]');
        this.change(line.dataset.key, Number(btn.dataset.lineChange));
      });

      // Upsell: 1 szt. → pakiet, a gdy pakiet jest w koszyku → inny produkt.
      this.upBox = el.querySelector('[data-drawer-upsell]');
      try { this.upsell = JSON.parse(el.querySelector('[data-mirela-upsell]')?.textContent || 'null'); }
      catch (_) { this.upsell = null; }
      this.upMode = null;
      this.upBox?.querySelector('[data-upsell-add]').addEventListener('click', () => this.acceptUpsell());
    }

    fill(tpl, vars) {
      return String(tpl || '').replace(/\[(\w+)\]/g, (m, k) => (k in vars ? vars[k] : m));
    }

    renderUpsell(cart) {
      const u = this.upsell;
      if (!u || !this.upBox) return;
      const lines = cart.items || [];
      const fromLine = lines.find((i) => i.variant_id === u.from);
      const toLine = lines.find((i) => i.variant_id === u.to);
      const hasPack = toLine || (fromLine && fromLine.quantity >= u.units);

      this.upMode = null;
      const nextMissing = u.next && !lines.some((i) => i.product_id === u.next.product_id);
      const canBundle = fromLine && !toLine && fromLine.quantity < u.units && u.available;
      if (u.next_first && nextMissing && (fromLine || hasPack)) this.upMode = 'next';
      else if (canBundle) this.upMode = 'bundle';
      else if (nextMissing && hasPack) this.upMode = 'next';

      this.upBox.hidden = !this.upMode;
      if (!this.upMode) return;

      let title, text, button, image, vars;
      if (this.upMode === 'bundle') {
        vars = {
          doplata: this.money(u.to_price - u.from_price),
          cena_sztuki: this.money(u.from_price),
          cena_pakietu: this.money(u.to_price),
          oszczednosc: this.money(u.units * u.from_price - u.to_price),
        };
        ({ title, text, button, image } = u);
      } else {
        const n = u.next;
        vars = {
          produkt: n.name,
          cena: this.money(n.price),
          cena_regularna: n.compare > n.price ? this.money(n.compare) : '',
          oszczednosc: n.compare > n.price ? this.money(n.compare - n.price) : '',
        };
        ({ title, text, button, image } = n);
      }
      this.upBox.querySelector('[data-upsell-title]').textContent = this.fill(title, vars);
      const textEl = this.upBox.querySelector('[data-upsell-text]');
      textEl.textContent = this.fill(text, vars);
      textEl.hidden = !textEl.textContent.trim();
      this.upBox.querySelector('[data-upsell-add]').textContent = button;
      this.upBox.querySelector('[data-upsell-error]').textContent = '';
      const img = this.upBox.querySelector('[data-upsell-img]');
      if (image) { img.src = image; img.hidden = false; } else { img.hidden = true; }
    }

    async acceptUpsell() {
      const u = this.upsell;
      const btn = this.upBox.querySelector('[data-upsell-add]');
      const errorBox = this.upBox.querySelector('[data-upsell-error]');
      btn.classList.add('is-loading');
      this.el.classList.add('is-busy');
      try {
        let res;
        if (this.upMode === 'bundle') {
          const cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
          const fromLine = cart.items.find((i) => i.variant_id === u.from);
          res = await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              updates: { [u.from]: Math.max(0, (fromLine?.quantity || 1) - 1), [u.to]: 1 },
              sections: ['cart-icon-bubble'],
            }),
          });
        } else if (this.upMode === 'next') {
          res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: u.next.variant, quantity: 1 }], sections: ['cart-icon-bubble'] }),
          });
        } else return;
        const data = await res.json();
        if (!res.ok || data.status) {
          errorBox.textContent = data.description || data.message || 'Nie udało się zaktualizować koszyka.';
          return;
        }
        updateBubble(data.sections);
        await this.refresh();
      } catch (err) {
        errorBox.textContent = 'Problem z połączeniem. Spróbuj ponownie.';
      } finally {
        btn.classList.remove('is-loading');
        this.el.classList.remove('is-busy');
      }
    }
    money(cents) { return this.fmt.format(cents / 100); }
    isOpen() { return this.el.classList.contains('is-open'); }

    async open() {
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      this.el.querySelector('.mirela-drawer__close')?.focus();
      await this.refresh();
    }
    close() {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      this.lastFocus?.focus?.();
    }

    async refresh(cart) {
      if (!cart) {
        const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        cart = await res.json();
      }
      if (window.mirelaAddonGuard) cart = await window.mirelaAddonGuard(cart);
      if (cart.fixed) updateBubble(cart.sections);
      this.render(cart);
    }

    render(cart) {
      if (!cart.item_count) {
        this.items.innerHTML = this.emptyHTML;
        this.foot.hidden = true;
        if (this.upBox) this.upBox.hidden = true;
        return;
      }
      this.items.innerHTML = cart.items.map((item) => {
        let img = '';
        if (item.image) {
          try { const u = new URL(item.image, window.location.origin); u.searchParams.set('width', '160'); img = u.toString(); }
          catch (_) { img = item.image; }
        }
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mirela-line__variant">${esc(item.variant_title)}</div>` : '';
        return `
          <div class="mirela-line" data-key="${esc(item.key)}" data-qty="${item.quantity}">
            ${img ? `<img src="${esc(img)}" alt="" width="76" height="76" loading="lazy">` : '<span></span>'}
            <div>
              <div class="mirela-line__title">${esc(item.product_title)}</div>
              ${variant}
              <div class="mirela-line__row">
                <div class="mirela-qty">
                  <button type="button" data-line-change="-1" aria-label="Zmniejsz ilość">−</button>
                  <span>${item.quantity}</span>
                  <button type="button" data-line-change="1" aria-label="Zwiększ ilość">+</button>
                </div>
                <span class="mirela-line__price">${this.money(item.final_line_price)}</span>
              </div>
              <button type="button" class="mirela-line__remove" data-line-change="0">Usuń</button>
            </div>
          </div>`;
      }).join('');
      this.total.textContent = this.money(cart.total_price);
      this.foot.hidden = false;
      this.renderUpsell(cart);
    }

    async change(key, delta) {
      const line = this.items.querySelector(`[data-key="${CSS.escape(key)}"]`);
      const qty = delta === 0 ? 0 : Math.max(0, Number(line?.dataset.qty || 0) + delta);
      this.el.classList.add('is-busy');
      try {
        const res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty, sections: ['cart-icon-bubble'] }),
        });
        let cart = await res.json();
        if (window.mirelaAddonGuard) cart = await window.mirelaAddonGuard(cart);
        updateBubble(cart.sections);
        this.render(cart);
      } finally {
        this.el.classList.remove('is-busy');
      }
    }
  }

  /* Odświeża ikonkę koszyka w nagłówku (sekcja Dawn cart-icon-bubble). */
  function updateBubble(sections) {
    const html = sections?.['cart-icon-bubble'];
    const bubble = document.getElementById('cart-icon-bubble');
    if (!html || !bubble) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const inner = doc.querySelector('.shopify-section');
    if (inner) bubble.innerHTML = inner.innerHTML;
  }

  /* ---------- Główna sekcja produktu ---------- */
  function initProduct(root) {
    const form = document.getElementById(root.dataset.formId);
    const variants = JSON.parse(root.querySelector('[data-mirela-variants]')?.textContent || '[]');
    const drawerEl = root.querySelector('[data-mirela-drawer]');
    const drawer = drawerEl ? new Drawer(drawerEl, root.dataset.currency) : null;
    const gallery = root.querySelector('[data-mirela-gallery]');
    const galleryCtl = gallery ? initCarousel(gallery) : null;

    const priceBox = root.querySelector('[data-price]');
    const omnibus = root.querySelector('[data-omnibus]');
    const atc = form?.querySelector('[data-atc]');
    const atcLabel = form?.querySelector('[data-atc-label]');
    const errorBox = form?.querySelector('[data-form-error]');
    const stickyPrice = root.querySelector('[data-sticky-price]');

    // Szuflada przenoszona do <body>, żeby nie blokowały jej transformacje rodziców.
    if (drawerEl) document.body.appendChild(drawerEl);
    if (drawer) window.mirelaDrawer = drawer;

    /* Zmiana wariantu */
    function applyVariant(id) {
      const v = variants.find((x) => x.id === Number(id));
      if (!v) return;
      if (priceBox) {
        const onSale = v.compare_at_price > v.price;
        priceBox.dataset.onSale = String(onSale);
        priceBox.querySelector('[data-price-current]').textContent = v.price_formatted;
        priceBox.querySelector('[data-price-compare]').textContent = v.compare_formatted;
        priceBox.querySelector('[data-price-badge]').textContent = onSale
          ? '-' + Math.floor(((v.compare_at_price - v.price) * 100) / v.compare_at_price) + '%'
          : '';
      }
      if (omnibus) omnibus.textContent = v.omnibus || '';
      if (stickyPrice) stickyPrice.textContent = v.price_formatted;
      const buyNowBtn = form?.querySelector('[data-buy-now]');
      if (buyNowBtn) buyNowBtn.disabled = !v.available;
      if (atc) {
        atc.disabled = !v.available;
        atcLabel.textContent = v.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
      }
      if (v.media_id && galleryCtl) {
        const idx = galleryCtl.slides.findIndex((s) => s.dataset.mediaId === String(v.media_id));
        if (idx > -1) galleryCtl.goTo(idx);
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    root.querySelectorAll('[data-variant-radio]').forEach((r) => {
      r.addEventListener('change', () => r.checked && applyVariant(r.value));
    });

    /* Ilość */
    form?.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      const i = form.querySelector('input[name="quantity"]');
      i.value = Math.max(1, Number(i.value) - 1);
    });
    form?.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      const i = form.querySelector('input[name="quantity"]');
      i.value = Number(i.value) + 1;
    });

    /* Dodawanie do koszyka (bez przeładowania). Bez JS formularz działa normalnie. */
    form?.addEventListener('submit', async (e) => {
      if (!drawer) return;
      e.preventDefault();
      const buyNow = !!e.submitter?.hasAttribute('data-buy-now');
      const btn = buyNow ? e.submitter : atc;
      errorBox.textContent = '';
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      try {
        const body = new FormData(form);
        body.delete('return_to');
        body.append('sections', 'cart-icon-bubble');
        body.append('sections_url', window.location.pathname);
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
        const data = await res.json();
        if (!res.ok || data.status) {
          errorBox.textContent = data.description || data.message || 'Nie udało się dodać do koszyka. Spróbuj ponownie.';
          return;
        }
        if (buyNow) {
          window.location.href = '/checkout';
          return;
        }
        updateBubble(data.sections);
        await drawer.open();
      } catch (err) {
        errorBox.textContent = 'Problem z połączeniem. Spróbuj ponownie.';
      } finally {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-busy');
      }
    });

    /* Ikona koszyka w nagłówku otwiera szufladę zamiast strony koszyka */
    if (drawer) {
      const cartUrl = root.dataset.cartUrl || '/cart';
      document.addEventListener('click', (e) => {
        const link = e.target.closest('#cart-icon-bubble, header a[href="' + cartUrl + '"]');
        if (!link || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        drawer.open();
      });
    }

    /* Pasek zakupu — widoczny, gdy główny przycisk zniknie z ekranu (po przewinięciu w dół) */
    const sticky = root.querySelector('[data-mirela-sticky]');
    if (sticky && atc && 'IntersectionObserver' in window) {
      document.body.appendChild(sticky);
      const stickyBtn = sticky.querySelector('[data-sticky-atc]');
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', () => {
        if (atc.disabled) {
          root.scrollIntoView({ behavior: 'smooth' });
          return;
        }
        form.requestSubmit ? form.requestSubmit(atc) : atc.click();
      });
    }
  }

  /* ---------- Szybkie dodanie (cross-sell) → ta sama szuflada ---------- */
  function initQuickAdd() {
    document.querySelectorAll('form[data-mirela-quick-add]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        if (!window.mirelaDrawer) return; // bez szuflady: zwykłe przejście do koszyka
        e.preventDefault();
        const btn = form.querySelector('[name="add"]');
        const errorBox = form.querySelector('[data-form-error]');
        errorBox.textContent = '';
        btn.classList.add('is-loading');
        try {
          const body = new FormData(form);
          body.append('sections', 'cart-icon-bubble');
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
          const data = await res.json();
          if (!res.ok || data.status) {
            errorBox.textContent = data.description || data.message || 'Nie udało się dodać do koszyka.';
            return;
          }
          updateBubble(data.sections);
          await window.mirelaDrawer.open();
        } catch (err) {
          errorBox.textContent = 'Problem z połączeniem. Spróbuj ponownie.';
        } finally {
          btn.classList.remove('is-loading');
        }
      });
    });
  }

  /* ---------- Wideo: odtwarzaj tylko, gdy widoczne ---------- */
  function initVideos() {
    const vids = document.querySelectorAll('video[data-autoplay-inview]');
    if (!vids.length) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window)) {
      vids.forEach((v) => { v.preload = 'metadata'; v.controls = true; });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (isIntersecting) {
          if (target.preload === 'none') { target.preload = 'auto'; target.load(); }
          if (!reduce) target.play().catch(() => { target.controls = true; });
          else target.controls = true;
        } else {
          target.pause();
        }
      });
    }, { threshold: 0.4 });
    vids.forEach((v) => io.observe(v));
  }

  /* ---------- Paski statystyk ---------- */
  function initStats() {
    document.querySelectorAll('[data-mirela-stats]').forEach((el) => {
      if (!('IntersectionObserver' in window)) { el.classList.add('is-inview'); return; }
      const io = new IntersectionObserver(([e]) => {
        if (e.isIntersecting) { el.classList.add('is-inview'); io.disconnect(); }
      }, { threshold: 0.3 });
      io.observe(el);
    });
  }

  /* ---------- Opinie: „pokaż więcej” ---------- */
  function initReviews() {
    document.querySelectorAll('[data-mirela-reviews]').forEach((sec) => {
      sec.querySelector('[data-reviews-more]')?.addEventListener('click', (e) => {
        sec.querySelectorAll('[data-extra]').forEach((r) => { r.hidden = false; });
        e.currentTarget.parentElement.remove();
      });
    });
  }

  /* ---------- Przyciski „przewiń do zakupu” ---------- */
  function initScrollBuy() {
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-scroll-buy]');
      if (!a) return;
      const target = document.getElementById('MirelaBuy');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-mirela-product]').forEach(initProduct);
    document.querySelectorAll('[data-mirela-carousel]').forEach(initCarousel);
    initQuickAdd();
    initVideos();
    initStats();
    initReviews();
    initScrollBuy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
